import { createGtm } from '@gtm-support/vue-gtm'
import type { RouteLocationNormalized } from 'vue-router'
import { defineNuxtPlugin, useRuntimeConfig, useRouter, useState } from '#imports'

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig().public

    if (config.gtmEnabled === 'disabled') return
    if (!config.gtmContainerId) {
        console.warn('GTM: Please provide a valid container id')
        return
    }

    // useState is safe in plugins (uses nuxtApp.payload.state, no provide/inject).
    // The actual values are synced by useGtmTracking (runs in setup context via app.vue).
    const gtmUserType = useState<'logged_in' | 'guest'>('gtm-user-type', () => 'guest')
    const gtmUserId = useState<string | undefined>('gtm-user-id', () => undefined)

    nuxtApp.vueApp.use(createGtm({
        enabled: config.gtmEnabled !== 'enabledOnConsent',
        id: config.gtmContainerId,
        ...(config.gtmSource && { source: config.gtmSource }),
        defer: true,
        compatibility: config.gtmCompatibility,
        ...(config.gtmNonce && { nonce: config.gtmNonce }),
        debug: config.gtmDebug,
        loadScript: true,
        vueRouter: useRouter(),
        trackOnNextTick: true,
        vueRouterAdditionalEventData: async (_to: RouteLocationNormalized, _from: RouteLocationNormalized) => ({
            user_type: gtmUserType.value,
            ...(gtmUserType.value === 'logged_in' && gtmUserId.value != null && { user_id: gtmUserId.value }),
        }),
    }))
})
